<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const platformSchema = defineSchema({
	image: $.upload('Image URL', { height: '90px', icon: 'image', placeholder: 'Upload Image' }),
	alt: $.text('Alt Text'),
	desc: $.text('Description', { multiline: true }),
	isComplex: $.checkbox('Is Complex'),
	subImage: $.text('Sub Image URL'),
	subAlt: $.text('Sub Alt Text'),
	link: $.text('Link'),
})
const defaults = {
	title: 'Our publications include:',
	platforms: [
		{
			img: '/images/the-torah.svg',
			alt: 'The Torah',
			desc: 'Our flagship platform launched in 2013',
			isComplex: false,
			link: 'https://thetorah.com',
		},
		{
			img: '/images/the-torah-he.svg',
			alt: 'התורה',
			desc: 'Our Hebrew-language sister site',
			isComplex: false,
			link: 'https://thetorah.co.il',
		},
		{
			img: '/images/the-gemara.svg',
			alt: 'The Gemara',
			desc: 'Academic scholarship on the Talmud and rabbinic texts',
			isComplex: false,
			link: 'https://thegemara.com',
		},
		{
			img: '/images/book.png',
			alt: 'Book',
			desc: 'A forthcoming Hebrew Chumash with source divisions and critical notes, currently in production',
			isComplex: true,
			subImg: '/images/Academic-Chumash.svg',
			subAlt: 'Academic Chumash',
			link: 'https://www.thetorah.com/store/chumash-bereshit',
		},
	] as platform[],
}
const schema = defineSchema({
	title: $.text('Title'),
	platforms: $.array('Platforms', platformSchema, { collapsible: true }),
})
export const OurWork = defineBlock({ name: 'OurWork', label: 'Our Work / Publications', icon: 'book', order: 3, schema, defaults })
</script>
<script setup lang="ts">

import { $ } from '@bagelink/vue'
interface platform {
	img: string
	alt: string
	desc: string
	isComplex: boolean
	subImg?: string
	subAlt?: string
	link: string
}





const myData = defineProps<{
	title?: string
	platforms?: platform[]
}>()
</script>

<template>
	<div id="publications" class="bg-gray-light py-6 relative overflow-hidden">
		<div class="w1050px txt-center relative z-2 m_px-1" style="--bgl-border-color: var(--bgl-gray);">
			<h3 class="m-0 txt36 regular m_txt30 line-height-13 balance">
				{{ myData.title }}
			</h3>
			<div class="flex justify-content-center gap-2 pt-4 m_column m_pt-3">
				<template v-for="(item, idx) in myData.platforms" :key="item.alt">
					<a v-if="!item.isComplex" :href="item.link" target="_blank" class=" decoration-none">
						<img :src="item.img" :alt="item.alt" :class="idx === 0 ? 'theTorahlogo' : 'h40px'">
						<p class="balance pt-1 m_w-300px">
							{{ item.desc }}
						</p>
					</a>
					<a v-else class="flex gap-1 m_column decoration-none" :href="item.link" target="_blank">
						<img :src="item.img" :alt="item.alt" class="h150px book">
						<div>
							<img :src="item.subImg" :alt="item.subAlt" class="h40px">
							<p class="balance pt-1 m_w-300px">
								{{ item.desc }}
							</p>
						</div>
					</a>
					<div
						v-if="idx < (myData.platforms?.length ?? 0) - 1"
						class="border-end h-150px m_border-end-none m_h-auto m_border-bottom m_opacity-2 m_px-7"
					/>
				</template>
			</div>
		</div>
	</div>
</template>

<style>
.book{
	filter: drop-shadow(4px 7px 10px var(--bgl-gray));
	transform: rotate(2deg);
}
.theTorahlogo{
	width: 410px;
	max-height: 46px;
}
</style>
